export enum CourseStatus {
    NotStarted = 'Not Started',
    Incomplete = 'Incomplete',
    Reviewed = 'Reviewed',
    Completed = 'Completed'
}